import Vue from 'vue'
import {ValidationProvider, ValidationObserver, localize, extend, setInteractionMode} from 'vee-validate';
import fa from 'vee-validate/dist/locale/fa.json';
import * as rules from 'vee-validate/dist/rules';


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


setInteractionMode('custom', ({errors}) => {
    if (errors.length) {
        return {
            on: ['input', 'change']
        };
    }
    return {
        on: ['change']
    };
});


localize('fa', fa);

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});